import axios from "axios";
import {
  terapiasBackendBase,
  axiosTerapiaConfig,
  getVistaTerapiaSecret,
} from "./Core";

/** El PHP envía variable1 como boolean; por si el JSON llega como 1 / "true". */
function esRespuestaExitoVariable1(v) {
  return (
    v === true ||
    v === 1 ||
    v === "1" ||
    String(v).toLowerCase() === "true"
  );
}

function postAccesoCamaraForm(fields) {
  const vistaSecret = getVistaTerapiaSecret();
  const xurl = `${terapiasBackendBase}/accesoCamaraTerapia.php`;
  const data = new FormData();
  Object.keys(fields).forEach((key) => {
    data.append(key, fields[key] == null ? "" : String(fields[key]));
  });
  data.append("vistaTerapiaSecret", vistaSecret || "");
  return axios.post(xurl, data, {
    ...axiosTerapiaConfig,
    timeout: 45000,
    transformResponse: [
      (raw) => {
        if (raw != null && typeof raw === "object") {
          return raw;
        }
        if (typeof raw === "string" && raw.trim().charAt(0) === "{") {
          try {
            return JSON.parse(raw);
          } catch (e) {
            return raw;
          }
        }
        return raw;
      },
    ],
  });
}

function mensajeErrorDesdeRespuesta(variable2) {
  if (variable2 == null) return "No se pudo validar el acceso.";
  if (typeof variable2 === "string") {
    // Servidor antiguo sin boton validar_clave_acceso_camara.
    if (variable2.trim() === "Solicitud no válida.") {
      return "El servidor aún no tiene actualizado el acceso por código. Suba accesoCamaraTerapia.php al hosting e intente de nuevo.";
    }
    return variable2;
  }
  if (typeof variable2 === "object") {
    if (variable2.mensaje != null) return String(variable2.mensaje);
    if (variable2.message != null) return String(variable2.message);
  }
  return "No se pudo validar el acceso.";
}

/**
 * Valida la clave del día (correo) y, si aplica, devuelve URL HLS + expiresAt.
 * boton=validar_clave_acceso_camara — no exige cédulas ni estatus 4/12.
 */
export async function validarClaveAccesoCamara(codigoAcceso) {
  const codigo = String(codigoAcceso || "")
    .trim()
    .replace(/\s+/g, "")
    .toUpperCase();
  try {
    const res = await postAccesoCamaraForm({
      boton: "validar_clave_acceso_camara",
      codigoAcceso: codigo,
    });

    const variable1 = res.data && res.data.variable1;
    const variable2 = res.data && res.data.variable2;

    if (
      esRespuestaExitoVariable1(variable1) &&
      variable2 &&
      typeof variable2 === "object"
    ) {
      return { ok: true, data: variable2 };
    }
    return { ok: false, message: mensajeErrorDesdeRespuesta(variable2) };
  } catch (err) {
    const v2 =
      err.response && err.response.data && err.response.data.variable2;
    if (v2 != null) {
      return { ok: false, message: mensajeErrorDesdeRespuesta(v2) };
    }
    return {
      ok: false,
      message: err.message || "Error de red al contactar el servidor.",
    };
  }
}
